import classNames from 'classnames';

/** Returns the UI darkMode classnames based on the given boolean */
function darkClassNames(darkMode: boolean): string {
  return darkMode ? classNames('bp3-dark', 'darkmode-background') : '';
}
export default darkClassNames;
